import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ComplianceRequest, ComplianceRequestType, PendingComplianceRequestsResponse } from './compliance.model';

@Injectable({ providedIn: 'root' })
export class ComplianceApiService {
    private readonly apiUrl = environment.urls.api;
    private readonly _httpClient = inject(HttpClient);

    public getComplianceRequests(): Observable<ComplianceRequest[]> {
        return this._httpClient
            .get<PendingComplianceRequestsResponse>(`${this.apiUrl}/Compliance/requests`)
            .pipe(map((res) => res.requests ?? []));
    }

    public completeRequest(type: ComplianceRequestType): Observable<void> {
        return this._httpClient.post<void>(
            `${this.apiUrl}/Compliance/request/${type}/complete`,
            {}
        );
    }

    public completeRequests(types: ComplianceRequestType[]): Observable<void> {
        return this._httpClient.post<void>(
            `${this.apiUrl}/Compliance/requests/complete`,
            types
        );
    }
}
